import Axios from "axios";
import {
  SET_EMPLOYEE_SALARY_LIST,
  UNSET_EMPLOYEE_SALARY_LIST,
  SET_EMPLOYEE_SALARY_DETAILS,
  UNSET_EMPLOYEE_SALARY_DETAILS,
} from "@/store/mutation-types";
import {
  getEmployeeSalaryList as getEmployeeSalaryListApi,
  getEmployeeSalaryDetails as getEmployeeSalaryDetailsApi,
} from "@/store/api";

const state = {
  employeeSalaryList: [],
  employeeSalaryDetails: null,
};

const getters = {
  employeeSalaryList(state) {
    return state.employeeSalaryList;
  },
  employeeSalaryDetails(state) {
    return state.employeeSalaryDetails;
  },
};

const mutations = {
  [SET_EMPLOYEE_SALARY_LIST](state, data) {
    state.employeeSalaryList = data;
  },
  [UNSET_EMPLOYEE_SALARY_LIST](state) {
    state.employeeSalaryList = [];
  },
  [SET_EMPLOYEE_SALARY_DETAILS](state, data) {
    state.employeeSalaryDetails = data;
  },
  [UNSET_EMPLOYEE_SALARY_DETAILS](state) {
    state.employeeSalaryDetails = null;
  },
};

const actions = {
  getEmployeeSalaryList({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.get(`${getEmployeeSalaryListApi}`, { params: data })
        .then((response) => {
          commit(SET_EMPLOYEE_SALARY_LIST, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_EMPLOYEE_SALARY_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  getEmployeeSalaryDetails({ commit }, id) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.get(`${getEmployeeSalaryDetailsApi}/${id}`)
        .then((response) => {
          commit(SET_EMPLOYEE_SALARY_DETAILS, response.data.data || null);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_EMPLOYEE_SALARY_DETAILS);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

